module.exports = __webpack_public_path__ + "img/MacEng.a1c57160.png";